import { observer } from 'mobx-react';
import * as React from 'react';
import EditIcon from '../../../../../../../../Cutesies/EditIcon';
import { useOpenable } from '../../../../../../../../Modal/UseOpenable';
import { ExperienceResource } from '../../../../../../../Types';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import EditDatesModal from '../EditDatesModal';
import CalendarIcon from './CalendarIcon';
import DatePopover from './DatePopover';

interface Props {
  experienceResource: ExperienceResource;
  experienceStore: LearningDesignExperienceStore;
  store: LearningCollectionEditStore;
}

const DateContainer: React.FC<Props> = ({ experienceResource, experienceStore, store }) => {
  const { modalState, open, close } = useOpenable();
  return (
    <div className="flex cursor-pointer items-center text-sm">
      <CalendarIcon />
      <DatePopover experienceResource={experienceResource} experienceStore={experienceStore} />
      <button onClick={open} type="button" aria-label="Edit dates">
        <EditIcon />
      </button>
      <EditDatesModal
        close={close}
        modalState={modalState}
        experienceResource={experienceResource}
        experienceStore={experienceStore}
        store={store}
      />
    </div>
  );
};

export default observer(DateContainer);
